/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Faq_A5Inputs */

const en_sorter_faq_a5 = /** @type {(inputs: Sorter_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keys are compared using browser locale collation, so letters take priority over case and accents fold to their base letter. Feeding in Beta, alpha, Alpha returns alpha, Alpha, Beta, which is different from a code point sort.`)
};

const ko_sorter_faq_a5 = /** @type {(inputs: Sorter_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`키는 브라우저 로케일 정렬 규칙으로 비교되므로 글자가 대소문자보다 우선하고 악센트는 기본 글자로 접힙니다. Beta, alpha, Alpha를 넣으면 alpha, Alpha, Beta가 나오며, 이는 코드 포인트 정렬과 다릅니다.`)
};

const ja_sorter_faq_a5 = /** @type {(inputs: Sorter_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーはブラウザのロケール照合順序で比較されるため、文字が大文字小文字より優先し、アクセントは基底文字に畳まれます。Beta, alpha, Alpha を入れると alpha, Alpha, Beta が返り、これはコードポイント順とは異なります。`)
};

/**
* | output |
* | --- |
* | "Keys are compared using browser locale collation, so letters take priority over case and accents fold to their base letter. Feeding in Beta, alpha, Alpha ret..." |
*
* @param {Sorter_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_faq_a5 = /** @type {((inputs?: Sorter_Faq_A5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Faq_A5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_faq_a5(inputs)
	if (locale === "ko") return ko_sorter_faq_a5(inputs)
	return ja_sorter_faq_a5(inputs)
});